/* app/js/src/components/common/LiveIndicator/liveIndicator.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: none;
  margin-right: 15px;
  -ms-transform: translateY(0.3em);
  -webkit-transform: translateY(0.3em);
  transform: translateY(0.3em);
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
:host.live {
  display: block;
  -webkit-animation-delay: 0.5s;
  -webkit-animation-duration: 1s;
  -webkit-animation-name: live;
  -webkit-animation-fill-mode: both;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: cubic-bezier(0.6, 0.04, 0.54, 0.99);
  -webkit-animation-direction: alternate;
  -moz-animation-delay: 0.5s;
  -moz-animation-duration: 1s;
  -moz-animation-name: live;
  -moz-animation-fill-mode: both;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: cubic-bezier(0.6, 0.04, 0.54, 0.99);
  -mox-animation-direction: alternate;
  -o-animation-delay: 0.5s;
  -o-animation-duration: 1s;
  -o-animation-name: live;
  -o-animation-fill-mode: both;
  -o-animation-iteration-count: infinite;
  -o-animation-timing-function: cubic-bezier(0.6, 0.04, 0.54, 0.99);
  -o-animation-direction: alternate;
  animation-delay: 0.5s;
  animation-duration: 1s;
  animation-name: live;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.54, 0.99);
  animation-direction: alternate;
}
:host svg {
  -ms-transform: translateY(1px);
  -webkit-transform: translateY(1px);
  transform: translateY(1px);
}
@keyframes live {
  from {
    -webkit-filter: invert(50%);
    filter: invert(50%);
  }
  to {
    -webkit-filter: invert(0%);
    filter: invert(0%);
  }
}
/*# sourceMappingURL=liveIndicator.component.css.map */
